import { render, staticRenderFns } from "./GridNavigationItem.vue?vue&type=template&id=ff7a9b42&scoped=true&"
import script from "./GridNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./GridNavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./GridNavigationItem.vue?vue&type=style&index=0&id=ff7a9b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7a9b42",
  null
  
)

export default component.exports